/**
 * Configuration file for NorthBuilt Compass Chat Interface - DEMO VERSION
 *
 * This is the public demo deployment with no authentication.
 * All API endpoints are publicly accessible.
 */

import type { Config } from './types';

const CONFIG: Config = {
  // ============================================================
  // API Configuration (REST API Gateway)
  // ============================================================
  // REST API Gateway endpoint (no auth required for demo)
  REST_API_ENDPOINT:
    import.meta.env.VITE_REST_API_ENDPOINT ||
    'https://demo-api.compass.northbuilt.com/v1',

  // ============================================================
  // AWS Cognito Configuration (DISABLED for demo)
  // ============================================================
  // These values are not used since DEV_MODE is always true
  COGNITO_DOMAIN: '',
  COGNITO_CLIENT_ID: '',
  COGNITO_REDIRECT_URI: '',
  COGNITO_LOGOUT_URI: '',

  // ============================================================
  // Chat Configuration
  // ============================================================
  CONVERSATION_HISTORY_LIMIT:
    Number(import.meta.env.VITE_CONVERSATION_HISTORY_LIMIT) || 10,
  MAX_RESULTS: Number(import.meta.env.VITE_MAX_RESULTS) || 5,
  MAX_MESSAGE_LENGTH: Number(import.meta.env.VITE_MAX_MESSAGE_LENGTH) || 4000,

  // ============================================================
  // External Links
  // ============================================================
  DOCS_URL:
    import.meta.env.VITE_DOCS_URL || 'https://docs.compass.northbuilt.com',

  // ============================================================
  // Demo Mode Settings
  // ============================================================
  // DEV_MODE: Always true for the public demo - bypasses authentication
  DEV_MODE: true,

  // DEBUG: Enable detailed console logging
  DEBUG: import.meta.env.VITE_DEBUG === 'true',
};

// Log configuration on load (only in debug mode)
if (CONFIG.DEBUG) {
  console.log('Demo configuration loaded:', {
    hostname: window.location.hostname,
    devMode: CONFIG.DEV_MODE,
    restApiEndpoint: CONFIG.REST_API_ENDPOINT,
  });
}

export default CONFIG;
